export default "__VITE_ASSET__Dj$iORTz__"